__turbopack_context__.v({
  "claim-outcome": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome",
  "claim-outcome__contact": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__contact",
  "claim-outcome__contact-item": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__contact-item",
  "claim-outcome__copy": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__copy",
  "claim-outcome__heading": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__heading",
  "claim-outcome__icon": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__icon",
  "claim-outcome__media": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__media",
  "claim-outcome__more": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__more",
  "claim-outcome__more-heading": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__more-heading",
  "claim-outcome__panel": "ClaimOutcome-module-scss-module__LQ4fma__claim-outcome__panel",
});
